module.exports = __webpack_public_path__ + "img/starship-freighter.02b63f96.svg";